import React from 'react'

import { Box, MenuItem, Select, makeStyles } from '@material-ui/core'
import InputBase from '@material-ui/core/InputBase'
import SearchIcon from '@material-ui/icons/Search'

import { ORDER_STATUSES } from 'constants/returnsConst'

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ccc',
    borderRadius: 12,
    paddingLeft: theme.spacing(1),
    width: 400,
    height: 48,
    backgroundColor: '#fff',
  },
  searchIcon: {
    marginLeft: 8,
    color: '#888',
  },
  select: {
    minWidth: 120,
    borderRight: '1px solid #ccc',
    marginRight: theme.spacing(1),
  },
  input: {
    flexGrow: 1,
    border: 'none',
    outline: 'none',
    fontSize: 14,
    paddingLeft: theme.spacing(1),
    backgroundColor: 'transparent',
  },

  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  selectOrder: {
    width: '100%',
  },
}))

const FilterInput = ({ customFilter, setCustomFilter, handleNewFilter }) => {
  const classes = useStyles()

  const renderFilterOptions = () => {
    return ORDER_STATUSES.map((status) => (
      <MenuItem key={status?.id} value={status.id}>
        {status?.name}
      </MenuItem>
    ))
  }
  return (
    <Box className={classes.root}>
      <Box className={classes.inputContainer}>
        <Select
          value={customFilter.type}
          onChange={(e) => {
            setCustomFilter({
              type: e.target.value,
              value: null,
            })
          }}
          variant="standard"
          disableUnderline
          className={classes.select}
        >
          <MenuItem value={0} disabled>
            Filtros
          </MenuItem>
          <MenuItem value={1}>Número de orden</MenuItem>
          <MenuItem value={2}>Estado de orden</MenuItem>
        </Select>

        <SearchIcon className={classes.searchIcon} onClick={handleNewFilter} />
        {customFilter.type === 1 && (
          <>
            <InputBase
              placeholder="Buscar..."
              value={customFilter.value}
              onChange={(e) => {
                setCustomFilter({
                  ...customFilter,
                  value: e.target.value,
                })
              }}
              className={classes.input}
            />
          </>
        )}
        {customFilter.type === 2 && (
          <Select
            variant="outlined"
            className={classes.selectOrder}
            inputProps={{ className: classes.filterInput }}
            value={customFilter.value}
            onChange={(e) => {
              setCustomFilter({
                ...customFilter,
                value: e.target.value,
              })
            }}
          >
            <MenuItem value="" disabled>
              Seleccione
            </MenuItem>
            {renderFilterOptions()}
          </Select>
        )}
      </Box>
    </Box>
  )
}

export default FilterInput
